<bzg-modal-header>
  <span class="bzg-modal__header">{{data.title | translate}}</span>
</bzg-modal-header>
<bzg-modal-content>
  <div class="bz-space--stack-s">
      <label class="bz-form-label">{{'WORKING_TIME_SCHEMA.DATE_TYPE' | translate}}</label>
  </div>
  <bzg-select class="bz-space--stack-m" [placeholder]="'WORKING_TIME_SCHEMA.SELECT_DATE_TYPE' | translate" name="select" [(value)]="currentDateType">
    <bzg-option value="exact">{{'WORKING_TIME_SCHEMA.EXACT' | translate}}</bzg-option>
    <bzg-option value="range">{{'WORKING_TIME_SCHEMA.RANGE' | translate}}</bzg-option>
  </bzg-select>

  <div *ngIf="currentDateType==='exact'">
    <bzg-date-picker [(ngModel)]="onDate" name="on-date">
      {{'WORKING_TIME_SCHEMA.ON_DATE' | translate}}
    </bzg-date-picker>
  </div>
  <div class="working-time-add-modal__date-range" *ngIf="currentDateType==='range'">
    <bzg-date-picker [(ngModel)]="startDate" [maxDate]="finishDate" name="start-date">
      {{'WORKING_TIME_SCHEMA.START_DATE' | translate}}
    </bzg-date-picker>
    <bzg-date-picker [(ngModel)]="finishDate" [minDate]="startDate" name="finish-date">
      {{'WORKING_TIME_SCHEMA.FINISH_DATE' | translate}}
    </bzg-date-picker>
  </div>

  <div class="working-time-add-modal__date-hours" *ngIf="isWorking && currentDateType">
    <div class="working-time-add-modal__date-hours-element">
      <span class="bz-form-label">{{'WORKING_TIME_SCHEMA.FROM' | translate}}:</span>
      <bz-time-picker class="bz-timer-positon" *ngIf="true" [(dateInput)]="fromTime" [isVisible]="true" [showIcon]="false" (timeChange)="changeDatePicker($event, 0)"></bz-time-picker>
    </div>
    <div class="working-time-add-modal__date-hours-element">
      <span class="bz-form-label">{{'WORKING_TIME_SCHEMA.TO' | translate}}:</span>
      <bz-time-picker class="bz-timer-positon" *ngIf="true" [(dateInput)]="toTime" [isVisible]="true" [showIcon]="false" (timeChange)="changeDatePicker($event, 1)"></bz-time-picker>
    </div>
    <div class="working-time-add-modal__date-hours-btn">
      <bzg-button-icon class="working-time-add-modal__date-hours-add" [ngClass]="{'icon-edit-class': idEdit !== 0}" (click)="addHours()" [disabled]="arrayHoursWorking.length == 5" [icon]="setIcon()"></bzg-button-icon>
    </div>
  </div>

  <div class="working-time-add-modal__table" *ngIf="isWorking && arrayHoursWorking.length > 0">
    <div class="working-time-add-modal__table-header">
      <div class="working-time-add-modal__table-header-title">{{ 'WORKING_TIME_SCHEMA.FROM' | translate}}</div>
      <div class="working-time-add-modal__table-header-title">{{ 'WORKING_TIME_SCHEMA.TO' | translate}}</div>
      <div class="working-time-add-modal__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_EDIT' | translate}}</div>
      <div class="working-time-add-modal__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_DELETE' | translate}}</div>
    </div>
    <div class="working-time-add-modal__table-body" *ngFor="let hourWorking of arrayHoursWorking">
      <div>{{hourWorking.fromTime}}</div>
      <div>{{hourWorking.toTime}}</div>
      <bzg-button-icon [icon]="'icon-edit'" (click)="editHours(hourWorking)"></bzg-button-icon>
      <bzg-button-icon [icon]="'icon-delete'" (click)="deleteHours(hourWorking)"></bzg-button-icon>
    </div>
  </div>

</bzg-modal-content>
<bzg-modal-footer>
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m">{{'GLOBAL.CANCEL' | translate}}
  </bzg-button-secondary>
  <bzg-button-primary (click)="ok()" [disabled]="!btnEnable()">{{data.button | translate}}
  </bzg-button-primary>
</bzg-modal-footer>
